<div class="megamenu-soluciones">
  <div class="megamenu-soluciones__inner">
    <ul class="megamenu-soluciones__rail">
      @for (item of rail(); track item.key) {
        <li>
          <button
            type="button"
            class="megamenu-soluciones__rail-item"
            [class.is-active]="active() === item.key"
            (click)="setActive(item.key)"
            (focus)="setActive(item.key)"
          >
            {{ item.label }}
          </button>
        </li>
      }
    </ul>

    <div class="megamenu-soluciones__panels">
      @for (group of rail(); track group.key) {
        <div
          class="megamenu-soluciones__columns"
          [class.is-active]="active() === group.key"
        >
          @for (col of content()[group.key]; track $index) {
            <div class="megamenu-soluciones__col">
              @if (col.title) {
                @if (col.url) {
                  <a class="megamenu-soluciones__col-title" [routerLink]="col.url" (click)="onLinkClick()">{{ col.title }}</a>
                } @else {
                  <h4 class="megamenu-soluciones__col-title">{{ col.title }}</h4>
                }
              }
              <ul class="megamenu-soluciones__list">
                @for (link of col.items; track link.label) {
                  <li [class.megamenu-soluciones__heading-item]="link.heading" [class.megamenu-soluciones__option-item]="link.option">
                    @if (link.heading) {
                      @if (link.external) {
                        <a
                          class="megamenu-soluciones__heading"
                          [href]="link.url"
                          target="_blank"
                          rel="noopener"
                          (click)="onLinkClick()"
                        >
                          {{ link.label }}
                        </a>
                      } @else {
                        <a
                          class="megamenu-soluciones__heading"
                          [routerLink]="link.url"
                          (click)="onLinkClick()"
                        >
                          {{ link.label }}
                        </a>
                      }
                    } @else if (link.option) {
                      @if (link.external) {
                        <a
                          class="megamenu-soluciones__option"
                          [href]="link.url"
                          target="_blank"
                          rel="noopener"
                          (click)="onLinkClick()"
                        >
                          {{ link.label }}
                        </a>
                      } @else {
                        <a
                          class="megamenu-soluciones__option"
                          [routerLink]="link.url"
                          (click)="onLinkClick()"
                        >
                          {{ link.label }}
                        </a>
                      }
                    } @else {
                      @if (link.external) {
                        <a
                          class="megamenu-soluciones__link"
                          [href]="link.url"
                          target="_blank"
                          rel="noopener"
                          (click)="onLinkClick()"
                        >
                          {{ link.label }}
                        </a>
                      } @else {
                        <a
                          class="megamenu-soluciones__link"
                          [routerLink]="link.url"
                          (click)="onLinkClick()"
                        >
                          {{ link.label }}
                        </a>
                      }
                    }
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
